import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NumMinDigitPipe } from './num-min-digit.pipe';
import { PricePipe } from './price.pipe';
import { ShufflePipe } from './shuffle.pipe';
import { SafeHtmlCustomPipe } from "./safe-html.pipe";
import { SafeUrlPipe } from "./safe-url.pipe";
import { CartFilterPipe } from './cart-filter.pipe';



@NgModule({
  declarations: [
    NumMinDigitPipe,
    PricePipe,
    ShufflePipe,
    SafeHtmlCustomPipe,
    SafeUrlPipe,
    CartFilterPipe,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PricePipe,
    ShufflePipe,
    NumMinDigitPipe,
    SafeHtmlCustomPipe,
    SafeUrlPipe,
    CartFilterPipe,
  ]
})
export class PipesModule {
}
